import React, { useState } from 'react';
import Iframe from 'react-iframe';
import OverlayPanel, {
  DesktopVariants,
} from '@havenengineering/module-shared-library/dist/components/OverlayPanel';
import Icon from '../../widget/icon';
import asset from '../../../../helpers/assets';

import styles from './matterport-frame.module.scss';

type Props = {
  matterportId: string;
  showLabel?: boolean;
};

export const MatterPortFrame: React.FC<Props> = ({ matterportId, showLabel = true }) => {
  const [overlayOpen, setOverlayOpen] = useState(false);

  return (
    <>
      <div className={styles.matterPortRoot}>
        <button
          type="button"
          onClick={() => setOverlayOpen(true)}
          className={styles.matterPortButton}
        >
          <img
            className={styles.matterPortImage}
            src={`https://my.matterport.com/api/v1/player/models/${matterportId}/thumb`}
            alt="Matterport virtual tour"
          />
          <span className="srOnly">Open virtual tour</span>
          <span className={styles.decoration}>
            <Icon src={asset('virtual-tour-dark-blue.svg')} alt="" className={styles.icon} />
            {showLabel && <p className={styles.description}>Virtual tour</p>}
          </span>
        </button>
      </div>
      <OverlayPanel
        open={overlayOpen}
        level={2}
        backButton
        backButtonLabel="Back"
        desktopVariant={DesktopVariants.FULLSCREEN}
        setPanelOpen={() => setOverlayOpen(false)}
      >
        <div className={styles.matterPortFrameContent}>
          <Iframe
            url={`https://my.matterport.com/show/?m=${matterportId}&play=1&fp=0`}
            width="100%"
            height="100%"
            id="matterportId"
            allowFullScreen
            allow="xr-spatial-tracking"
            display="inline"
            position="relative"
          />
        </div>
      </OverlayPanel>
    </>
  );
};
